import { render } from "./SymbolIcon.vue?vue&type=template&id=41198d7c&scoped=true"
import script from "./SymbolIcon.vue?vue&type=script&lang=js"
export * from "./SymbolIcon.vue?vue&type=script&lang=js"

import "./SymbolIcon.vue?vue&type=style&index=0&id=41198d7c&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41198d7c"]])

export default __exports__